import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';

import { localizable } from '../../../components/Localization';

import { saleCommandItems } from './saleCommandItems';
import { roundCommandItems } from './roundCommandItems';
import { bidderCommandItems } from './bidderCommandItems';
import { offerCommandItems } from './offerCommandItems';

@localizable
@observer
export default class Commands extends Component {
  render() {
    var { app, user, store, t } = this.props;

    const items = [].concat(
      bidderCommandItems(app, user, store, t),
      offerCommandItems(app, store, t),
      saleCommandItems.items(app, store, t)
    );

    const farItems = [].concat(
      saleCommandItems.farItems(app, store, t),
      roundCommandItems(app, store, t)
    );

    return <CommandBar items={items} farItems={farItems} />;
  }
}



// WEBPACK FOOTER //
// ./src/app/containers/Sale/Commands/index.jsx